import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class TwoStepAuthenticationForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		var Validator = validatorjs;
		Validator.register(
			'verificationCodeFormat',
			value => {
				return value.match(/^\d+$/); // Allow only numbers, no whitespace and no special characters.
			},
			'TWOSTEPAUTHENTICATION.INVALIDVERIFICATIONCODEFORMAT'
		);
		Validator.register(
			'verificationCodeLength',
			value => {
				return value.match(/\b\w{6}\b/); // Code must be 6 digits long.
			},
			'TWOSTEPAUTHENTICATION.INVALIDVERIFICATIONCODELENGTH'
		);

		return {
			fields: [
				{
					name: 'verificationCode',
					label: 'TWOSTEPAUTHENTICATION.VERIFICATIONCODE',
					rules: 'required|verificationCodeFormat|verificationCodeLength',
					options: {
						validateOnChange: false,
					},
				},
				{
					name: 'sms',
				},
				{
					name: 'voiceCall',
				},
				{
					name: 'email',
				},
				{
					name: 'phoneNumber',
					label: 'TWOSTEPAUTHENTICATION.PHONENUMBER',
				},
				{
					name: 'countryCodeId',
					label: 'TWOSTEPAUTHENTICATION.COUNTRYCODE',
				},
			],
		};
	}
}
